export class AddSectionFromTemplateError extends Error {
  constructor(
    message: string = 'Failed to add section to inspection template',
    options?: ErrorOptions
  ) {
    super(message, options);
    this.name = 'AddSectionFromTemplateError';
  }
}
